// @flow
import NavigationPills from '@shared/Navigation/NavigationPills/components/NavigationPills';

export default NavigationPills;
